"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var transitionNatural = exports.transitionNatural = "all 300ms ease";
var transitionEntrance = exports.transitionEntrance = "all 300ms ease-out";
var transitionExit = exports.transitionExit = "all 300ms ease-in";